import { useState } from 'react';
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import SvgRender from 'common/components/general/SvgRender';
import indexValue from 'assets/svg/actions/value.svg';
import close from 'common/assets/svg/actions/close.svg';

const BulkActions = ({ onBulkSelect, onBulkClose, onSelectIndexValue, isRowSelectable, label }) => {
  const options = [
    {
      label: 'Edit Index Value',
      icon: indexValue
    }
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => {
    onBulkSelect();
    setDropdownOpen(prevState => !prevState);
  };

  return (
    <div className="d-flex align-items-center cmb-12">
      {!isRowSelectable ? (
        <Button
          color="grey"
          className="cpt-4 cpb-4 border-radius-3 cpe-12 fw-medium cps-12 fs-12"
          onClick={onBulkSelect}
        >
          Bulk select
        </Button>
      ) : (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle
            color="lighter-blue"
            disabled={dropdownOpen}
            className="text-primary shadow-none cpt-4 cpb-4 border-radius-3 cpe-12 fw-medium cps-12 fs-12"
          >
            Bulk actions
          </DropdownToggle>
          <Button
            color="lighter-blue"
            className="cms-4 text-primary shadow-none cpt-4 cpb-4 border-radius-3 cpe-12 fw-medium cps-12 fs-12"
            onClick={onBulkClose}
          >
            <SvgRender src={close} style={{ width: 9, height: 9 }} />
          </Button>
          <DropdownMenu>
            {options.map(opt => (
              <DropdownItem
                onClick={onSelectIndexValue}
                className="d-flex align-items-center text-primary"
              >
                <SvgRender className="cme-10" src={opt.icon} style={{ width: 16, height: 16 }} />
                {opt.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
};

export default BulkActions;
